module.exports = __webpack_public_path__ + "img/9791188810451.1e30f510.jpg";